import { Direction } from "@local-types/direction/tableRow";
import { API_BASE_URL } from "./config";

export const fetchDirections = async (): Promise<Direction[]> => {
  const response = await fetch(`${API_BASE_URL}/directions`);
  if (!response.ok) {
    throw new Error("Ошибка загрузки направлений");
  }
  return response.json();
};

export const createDirection = async (
  name: string,
  description?: string,
): Promise<Direction> => {
  const response = await fetch(`${API_BASE_URL}/directions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name, description }),
  });

  if (!response.ok) {
    throw new Error("Ошибка создания направления");
  }

  return response.json();
};

export const updateDirection = async (
  id: number,
  updates: { name?: string; description?: string },
): Promise<Direction> => {
  const response = await fetch(`${API_BASE_URL}/directions/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updates),
  });

  if (!response.ok) {
    throw new Error("Ошибка обновления направления");
  }

  return response.json();
};

export const deleteDirection = async (id: number): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/directions/${id}`, {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error("Ошибка удаления направления");
  }
};
